<template>
  <default-dialog ref="dialog">
    <div class="file-type-unsupported">
      <div>
        <lottie-player
          :src="JSON.stringify(require('@/assets/animations/meh-smiley.json'))"
          style="width: 90px; height: 90px"
          autoplay/>
      </div>

      <div class="r-image-headline error-headline">יש בעיה עם הקובץ</div>

      <div class="r-text-regular text">
        אפשר להעלות רק קבצים מסוג Jpeg או Png.
        אפשר לעשות צילום מסך של הקובץ
        ולהעלות אותו כתמונה.
      </div>
      <dialog-button label="הבנתי" @click="okAndHide" />
    </div>
  </default-dialog>
</template>

<script>
import GlobalDialog from '@/components/base/GlobalDialog';
import DefaultDialog from '@/components/styled/DefaultDialog';
import DialogButton from '@/components/styled/DialogButton';

export default {
  name: 'FileTypeUnsupported',
  components: { DialogButton, DefaultDialog },
  mixins: [GlobalDialog],
};
</script>

<style scoped lang="scss">

.file-type-unsupported {

  margin-bottom: 16px;

  .error-headline {
    margin: 20px 0;
  }

  .text {
      margin-bottom: 16px;
  }
}

</style>
